const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'aircraftmap',

    viewClass: require('./view'),

    methods: {
        onOpenAircraftMap(seatMap, aircraftOptions) {
            this.openAircraftMap(seatMap, aircraftOptions);
        },

        onCloseAircraftMap(source) {
            this.onCloseAircraftMap(source);
        },

        onCloseAircraftMapBackButton() {
            this.onTapIconBackClose();
        },
        updateShoppingCart() {
            this.updateShoppingCart();
        },
    },
});
